import React from "react";
import styles from "./styles.m.css";
import { Link } from "@quintype/components";
import wretch from "wretch";

const API_URL = `/api/v1/collections/latest-news`;

export default class LastestNews extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: []
    };
  }

  componentDidMount() {
    const url = `${API_URL}`;

    wretch(url)
      .get()
      .json(res => {
        const data = res.items;
        this.setState({ data });
      });
  }

  render() {
    return (
      <div className="container">
        <div>
          <div>
            <ul className={styles["latest-list"]}>
              {this.state.data.splice(0, 20).map(late => (
                <li key={late.id} className={styles["li-list"]}>
                  <Link href={`${late.story.url}`}>{late.story.headline}</Link>
                  <Link href={`${late.story.sections[0]["section-url"]}`} className={styles["section-list"]}>
                    &nbsp;-&nbsp;
                    {late.story.sections[0].name}
                  </Link>
                </li>
              ))}
            </ul>
            <button className={styles["button"]}>
              <Link href={`https://www.vikatan.com/latest-news`}>More</Link>
            </button>
          </div>
          <div />
        </div>
      </div>
    );
  }
}

export { LastestNews };
